import ReactDOM from "react-dom/client";
import mapboxgl from "mapbox-gl";

let pins = [];
let cities = [];
let namedPins = {};

export const addPin = (map, PinComponent, point, offset = -21) => {
  if (!map) return;
  const markerContainer = document.createElement("div");
  const root = ReactDOM.createRoot(markerContainer);
  root.render(<PinComponent />);

  pins = [
    ...pins,
    new mapboxgl.Marker(markerContainer, {
      offset: [0, offset],
    })
      .setLngLat(point)
      .addTo(map),
  ];
};

export const addStateLines = async (map) => {
  const response = await fetch("/usa_continental.json");
  const data = await response.json();
  const marketsResponse = await fetch("/markets-v4.json");
  const marketsData = await marketsResponse.json();

  if (!map) return;
  try {
    map.addSource("states", {
      type: "geojson",
      data,
    });
    map.addSource("markets", {
      type: "geojson",
      data: marketsData,
    });
    map.addLayer({
      id: "states-line-layer",
      type: "line",
      source: "states",
      paint: {
        "line-color": "#FFFFFF",
        "line-width": 1.5,
        "line-dasharray": [4, 4],
      },
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
    });
  } catch (e) {
    console.log("Error adding state line", e);
  }
};

export const removePolyline = (map) => {
  if (!map) return;
  if (map.getLayer("routeLine")) {
    map.removeLayer("routeLine");
  }
  if (map.getSource("routeLine")) {
    map.removeSource("routeLine");
  }
};

export const removeLocationPoints = (map) => {
  if (!map) return;
  if (map.getLayer("circle-point-delivery")) {
    map.removeLayer("circle-point-delivery");
  }
  if (map.getLayer("circle-point-dropOff")) {
    map.removeLayer("circle-point-dropOff");
  }
  if (map.getSource("circle-point-delivery")) {
    map.removeSource("circle-point-delivery");
  }
  if (map.getSource("circle-point-dropOff")) {
    map.removeSource("circle-point-dropOff");
  }
  if (map.getLayer("pickup-market-layer")) {
    map.removeLayer("pickup-market-layer");
  }
  if (map.getLayer("delivery-market-layer")) {
    map.removeLayer("delivery-market-layer");
  }
  removePins();
};

export const removePins = () => {
  pins.forEach((pin) => {
    pin.remove();
  });
  pins = [];
};

export const setMaxBounds = (map) => {
  if (!map) return;
  const maxBounds = [
    [-158.9479735916259, 20.251369814703864],
    [-33.4775307531346, 51.44634649986574],
  ];
  map.setMaxBounds(maxBounds);
};

export const addCity = (map, city) => {
  if (!map) return;
  const cityContainer = document.createElement("div");
  const root = ReactDOM.createRoot(cityContainer);
  root.render(
    <div className="flex flex-col items-center">
      <div className="rounded-full w-2 h-2 bg-cm-text-primary border border-cm-background border-1" />
      <div className="bold-by-shadow text-[11px] leading-[17px] font-semibold font-sans text-cm-text-primary">{city.name}</div>
    </div>,
  );

  cities = [
    ...cities,
    new mapboxgl.Marker(cityContainer, {
      offset: [0, 4],
    })
      .setLngLat(city.coordinates)
      .addTo(map),
  ];
};

export const removeCities = () => {
  cities.forEach((city) => {
    city.remove();
  });
  cities = [];
};

export const fitBounds = (map, padding, duration) => {
  const bounds = [
    [-126, 50.9],
    [-67.93, 23.3],
  ];

  if (map) {
    map.fitBounds(bounds, { padding, duration });
  }
};

export const addNamedPins = (name, map, PinComponent, point, offset = -21) => {
  if (!map) return;
  const markerContainer = document.createElement("div");
  const root = ReactDOM.createRoot(markerContainer);
  root.render(<PinComponent />);

  if (!namedPins[name]) {
    namedPins[name] = [];
  }

  namedPins[name] = [
    ...namedPins[name],
    new mapboxgl.Marker(markerContainer, {
      offset: [0, offset],
    })
      .setLngLat(point)
      .addTo(map),
  ];
};

export const removeNamedPins = (name) => {
  namedPins[name]?.forEach((pin) => {
    pin.remove();
  });
  namedPins[name] = [];
};
